<template>
  <span class="rounded-full  pb-1 pt-1 pl-2 pr-2 bg-primary-50 dark:bg-darkblue text-primary-800 dark:text-primary-600 border-2 tag-cell">
    {{ tagName }}
  </span>
</template>

<script>
import getEnumTranslatedValue from '@/services/functions/getEnumTranslatedValue'

export default {
  props: {
    field: String,
    format: String,
    tag: {
      type: [String, Number],
      required: true
    },
    extraparams: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
    }
  },
  computed: {
    tagName: function () {
      const idEnumField = this.idEnumField
      const valueEnumField = this.valueEnumField
      const ignoreNull = this.ignoreNull
      return getEnumTranslatedValue(this.tag, this.format, this.field, { idEnumField, valueEnumField, ignoreNull })
    },
    idEnumField: function () {
      return this.extraparams?.idEnum
    },
    valueEnumField: function () {
      return this.extraparams?.valueEnum
    },
    ignoreNull: function () {
      return this.extraparams?.ignoreNull ?? true
    },
  },
  methods: {
  },
}
</script>

<style>

</style>
